import { Component } from "vue";
import {
  ETipoVisualizacao,
  FIELD_SIZE_SPAN
} from "../../../../@types/IntegracaoCampoEnum";
import { TIntegracaoCampoModel } from "../../../../@types/IntegracaoCampoModel";
import SelectFieldRenderer from "../../../../renderers/fields/SelectFieldRenderer/SelectFieldRenderer.vue";
import PasswordFieldRenderer from "../../../../renderers/fields/PasswordFieldRenderer/PasswordFieldRenderer.vue";
import CheckboxFieldRenderer from "../../../../renderers/fields/CheckboxFieldRenderer.vue";
import NumberFieldRenderer from "../../../../renderers/fields/NumberFieldRenderer/NumberFieldRenderer.vue";
import DateFieldRenderer from "../../../../renderers/fields/DateFieldRenderer.vue";
import RadioFieldRenderer from "../../../../renderers/fields/RadioFieldRenderer.vue";
import InputTagNumberFieldRenderer from "../../../../renderers/fields/InputTagNumberFieldRenderer/InputTagNumberFieldRenderer.vue";
import InputTextFieldRenderer from "../../../../renderers/fields/InputTextFieldRenderer.vue";
import ButtonFieldRenderer from "../../../../renderers/fields/ButtonFieldRenderer/ButtonFieldRenderer.vue";
import UploadFieldRenderer from "../../../../renderers/fields/UploadFieldRenderer.vue";
import BannerFieldRenderer from "../../../../renderers/fields/BannerFieldRenderer.vue";
import DividerFieldRenderer from "../../../../renderers/fields/DividerFieldRenderer.vue";
import InputTagMarcadoresFieldRenderer from "../../../../renderers/fields/InputTagMarcadoresFieldRenderer/InputTagMarcadoresFieldRenderer.vue";
import RemoteCollectionFieldRenderer from "../../../../renderers/fields/RemoteCollectionFieldRenderer/RemoteCollectionFieldRenderer.vue";
import InfoTextFieldRenderer from "../../../../renderers/fields/InfoTextFieldRenderer.vue";
import CheckboxGroupFieldRenderer from "../../../../renderers/fields/CheckboxGroupFieldRenderer/CheckboxGroupFieldRenderer.vue";

export default function useFieldRegistry() {
  const fieldRegistry: Record<ETipoVisualizacao, Component> = {
    [ETipoVisualizacao.TEXT]: InputTextFieldRenderer,
    [ETipoVisualizacao.SELECT]: SelectFieldRenderer,
    [ETipoVisualizacao.PASSWORD]: PasswordFieldRenderer,
    [ETipoVisualizacao.CHECKBOX]: CheckboxFieldRenderer,
    [ETipoVisualizacao.NUMBER]: NumberFieldRenderer,
    [ETipoVisualizacao.SELECT_MULTIPLE]: SelectFieldRenderer,
    [ETipoVisualizacao.DATE]: DateFieldRenderer,
    [ETipoVisualizacao.RADIO]: RadioFieldRenderer,
    [ETipoVisualizacao.INPUT_TAG_NUMBER]: InputTagNumberFieldRenderer,
    [ETipoVisualizacao.INPUT_TAG_TEXT]: InputTagNumberFieldRenderer,
    [ETipoVisualizacao.BUTTON]: ButtonFieldRenderer,
    [ETipoVisualizacao.UPLOAD]: UploadFieldRenderer,
    [ETipoVisualizacao.BANNER]: BannerFieldRenderer,
    [ETipoVisualizacao.DIVIDER]: DividerFieldRenderer,
    [ETipoVisualizacao.TEXT_AREA]: InputTagMarcadoresFieldRenderer,
    [ETipoVisualizacao.REMOTE_COLLECTION]: RemoteCollectionFieldRenderer,
    [ETipoVisualizacao.INFO_TEXT]: InfoTextFieldRenderer,
    [ETipoVisualizacao.CHECKBOX_GROUP]: CheckboxGroupFieldRenderer
  };

  const resolveRenderer = (
    field: TIntegracaoCampoModel
  ): { tipo: ETipoVisualizacao; component: Component; tamanho: number } => {
    const type = field.tipo as unknown as ETipoVisualizacao;

    const fullWidthTypes = [
      ETipoVisualizacao.UPLOAD,
      ETipoVisualizacao.CHECKBOX,
      ETipoVisualizacao.REMOTE_COLLECTION,
      ETipoVisualizacao.INFO_TEXT,
      ETipoVisualizacao.CHECKBOX_GROUP
    ];

    const widthByFieldSize = field.fieldSize
      ? FIELD_SIZE_SPAN[field.fieldSize]
      : undefined;

    const width = fullWidthTypes.includes(type) ? 24 : (widthByFieldSize ?? 24);

    return {
      tipo: type,
      component: fieldRegistry[type] ?? InputTextFieldRenderer,
      tamanho: width
    };
  };

  return {
    fieldRegistry,
    resolveRenderer
  };
}
